import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const initialState = {
  deferralfileUploadTimeStamp: null,
  feefileUploadTimeStamp: null
}

export default function deferralPayments(state, action) {
	if (typeof state === "undefined") {
		return initialState;
	}

	let newState = null;

	switch (action.type) {
		case actionTypes.SET_DEFERRAL_FILE_UPLOAD_TIMESTAMP:
			newState = objectAssign({}, state);
			newState.deferralfileUploadTimeStamp = action.payload;
			return newState;
		case actionTypes.SET_FEE_FILE_UPLOAD_TIMESTAMP:
			newState = objectAssign({}, state);
			newState.feefileUploadTimeStamp = action.payload;
			return newState;
	}
	return state;
}